import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';
import { SportsDataModelType } from 'src/api/config/sports/getSingleCustomizedSport';
import { SingleSport } from 'src/main/cms/Sports/SportsList/SingleSport';
import { ListContainer, ErrorMessageTop } from 'src/domains/layouts/shared/cms/list/List.style';
import { Loader } from 'src/domains/layouts/shared/loader/Loader';


interface PropsTypes {
    sportState: CustomizedSportsState;
}

export const SportsList = observer('SportsList', ({sportState}: PropsTypes) => {
    const { errorMessageForList, isLoading, sportDetailsData } = sportState;

    return (
        <>
            {errorMessageForList !== null && <ErrorMessageTop>{errorMessageForList}</ErrorMessageTop>}

            <ListContainer areLoading={isLoading}>
                <Loader isActive={isLoading} />

                {sportDetailsData.map((sportData: SportsDataModelType) => (
                    <SingleSport key={sportData.id} sportState={sportState} sportData={sportData}/>
                ))}
            </ListContainer>
        </>
    );
});

